import React from 'react';

import LoadingDots from '../../../components/LoadingDots';

const CSS = require('./LoadingOverlay.module.scss');

function LoadingOverlay() {
  return (
    <div className={CSS['loadingContainer']}>
      <LoadingDots />
    </div>
  );
}

export default LoadingOverlay;
